import { IConsent } from './iConsent';
import Consent from './consent';

export type { IConsent };
export default Consent;
